import { render, staticRenderFns } from "./OtherUserReceiveMessageTable.vue?vue&type=template&id=59a9e06a&scoped=true&lang=pug"
import script from "./OtherUserReceiveMessageTable.vue?vue&type=script&lang=ts"
export * from "./OtherUserReceiveMessageTable.vue?vue&type=script&lang=ts"
import style0 from "./OtherUserReceiveMessageTable.vue?vue&type=style&index=0&id=59a9e06a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a9e06a",
  null
  
)

export default component.exports